import { formatGBP } from '@/utils/format';

/**
 * Renders a pence amount in accountant format for right-aligned columns.
 *
 * Negatives show as (£1,234.56); non-negative values are padded with an
 * INVISIBLE ")" — the same glyph the negatives end with, so it is exactly
 * the same width in any font — keeping the pence digits vertically aligned
 * down a column of mixed signs. (Character padding like nbsp is not reliably
 * bracket-width, which is how this bug survived its first fix.)
 *
 * Inherits all styling (font, colour, size) from the parent element.
 */
export default function Money({
  pence,
}: {
  pence: number | string | null | undefined;
}) {
  const text = formatGBP(pence);
  if (text.startsWith('(')) return <>{text}</>;
  return (
    <>
      {text}
      <span className="invisible" aria-hidden="true">
        )
      </span>
    </>
  );
}
